import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const APP_STORE_URL = "https://apps.apple.com"; // <-- replace
const PLAY_STORE_URL = "https://play.google.com/store/apps"; // <-- replace

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const closeMenu = () => setMenuOpen(false);

  const handleNavClick = (id) => {
    navigate(`/${id === "home" ? "" : `#${id}`}`);
    closeMenu();
  };

  const getOS = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const platform = navigator.platform.toLowerCase();

    // iOS devices
    if (/iPhone|iPad|iPod/i.test(ua)) return "ios";

    // iPadOS 13+ detection (reports as MacIntel but touch-capable)
    if (platform === "macintel" && navigator.maxTouchPoints > 1) return "ios";

    // macOS desktops/laptops
    if (platform.includes("mac")) return "macos";

    // Windows
    if (platform.includes("win")) return "windows";

    // Linux
    if (platform.includes("linux")) return "linux";

    return "other";
  };

  const handleAppRedirect = () => {
    const os = getOS();

    if (os === "ios" || os === "macos") {
      window.open(APP_STORE_URL, "_blank");
    } else {
      window.open(PLAY_STORE_URL, "_blank");
    }

    closeMenu(); // also close the menu if it's mobile
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 flex justify-center py-3 md:py-4 bg-transparent">
      <div className="bg-[#87004C] rounded-full px-6 md:px-10 py-3 flex items-center w-full max-w-7xl relative">
        {/* Logo */}
        <div className="flex flex-col leading-none mr-10">
          <span className="bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] bg-clip-text text-transparent font-bold text-2xl">
            AVITA
          </span>
          <span className="text-white text-[10px] tracking-[2px]">
            RESIDENCES
          </span>
        </div>

        {/* Nav */}
        <nav
          className={`md:flex flex-1 justify-center items-center gap-6 lg:gap-10 xl:gap-14 text-white text-base
            ${
              menuOpen
                ? "fixed inset-0 bg-[#87004C] flex flex-col justify-center items-center"
                : "hidden"
            }
          `}
        >
          <button onClick={() => handleNavClick("home")}>Home</button>
          <button onClick={() => handleNavClick("about")}>About Us</button>
          <button onClick={() => handleNavClick("branches")}>Branches</button>
          <button onClick={() => handleNavClick("facilities")}>
            Facilities
          </button>
          <button onClick={() => handleNavClick("platform-usage")}>
            Platform Usage
          </button>
          <button onClick={() => handleNavClick("contact")}>
            Get In Touch
          </button>

          {/* Mobile-only "Get The App" */}
          <button
            onClick={handleAppRedirect}
            className="mt-6 md:hidden bg-[linear-gradient(to_right,_#DFC355,_#FDF880,_#ECDA68)] text-landing_red font-semibold px-6 py-2 rounded-full"
          >
            Get The App
          </button>
        </nav>

        {/* CTA */}
        <div className="ml-auto flex items-center gap-3">
          {/* Desktop CTA */}
          <button
            onClick={handleAppRedirect}
            className="hidden md:inline-block bg-[linear-gradient(to_right,_#DFC355,_#FDF880,_#ECDA68)] text-landing_red font-semibold px-6 py-2 rounded-full"
          >
            Get The App
          </button>

          {/* Hamburger */}
          <button
            aria-label="Open menu"
            className="md:hidden text-white text-xl"
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
